import config from "../config/config.json";
import { headers } from "./../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../APIHelpers/Responses";

export const reportServices = {
  addNewReport,
  updateReport,
  softDeleteRestoreReport,
  deleteReport,
  getReportData,
};

async function addNewReport(payload) {
  const response = await fetch(
    `${config.API_URL}addNewReport`,
    headersWithAuth("POST", payload, headers)
  );
  const data = await response.json();
  // handleResponse(data);
  return data;
}

async function updateReport(payload) {
  const response = await fetch(
    `${config.API_URL}updateReport`,
    headersWithAuth("PUT", payload, headers)
  );
  const data = await response.json();
  // handleResponse(data);
  return data;
}

async function softDeleteRestoreReport(payload) {
  const response = await fetch(
    `${config.API_URL}softDeleteRestoreReport`,
    headersWithAuth("PUT", payload, headers)
  );
  const data = await response.json();
  // handleResponse(data);
  return data;
}

async function deleteReport(payload) {
  const response = await fetch(
    `${config.API_URL}deleteReport`,
    headersWithAuth("DELETE", payload, headers)
  );
  const data = await response.json();
  // handleResponse(data);
  return data;
}

async function getReportData(status = "active", queryParams = {}) {
  const query = new URLSearchParams();
  Object.entries(queryParams || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.append(key, value);
    }
  });

  const response = await fetch(
    `${config.API_URL}getReportData/${status}?${query.toString()}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}
